/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkPackageDynamicFormsSchemaRequest } from '../../models/update-work-package-dynamic-forms-schema-request';

export interface UpdateTemplateDynamicFormsSchema$Params {
  id: string;
      body: UpdateWorkPackageDynamicFormsSchemaRequest
}

export function updateTemplateDynamicFormsSchema(http: HttpClient, rootUrl: string, params: UpdateTemplateDynamicFormsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateTemplateDynamicFormsSchema.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateTemplateDynamicFormsSchema.PATH = '/v0/templates/{id}/dynamic-forms-schema';
